/**
 * Outline → filled para nav (Iconify + Tabler cuenta).
 *
 * Rail/dock: NO mutar `data-icon` (Iconify CDN no re-escanea el SVG).
 * Usar dos placeholders fijos + CSS (`app-nav-icon-pair`).
 */

const ICONIFY_FILLED_BY_IDLE: Readonly<Record<string, string>> = {
  'material-symbols-light:table-restaurant-outline-rounded':
    'material-symbols-light:table-restaurant-rounded',
  'tabler:external-link': 'tabler:external-link-filled',
};

/** Tabler names usados en `i-tabler` (menú cuenta). */
const TABLER_FILLED_BY_IDLE: Readonly<Record<string, string>> = {
  user: 'user-filled',
  'credit-card': 'credit-card-filled',
  diamond: 'diamond-filled',
  book: 'book-filled',
  settings: 'settings-filled',
};

/**
 * Variante filled Iconify (`prefix:name`), o el mismo id si no hay mapping.
 */
export function toFilledNavIcon(iconName: string | undefined | null): string {
  const idle = (iconName ?? '').trim();
  if (!idle) {
    return '';
  }

  const mapped = ICONIFY_FILLED_BY_IDLE[idle];
  if (mapped) {
    return mapped;
  }

  if (idle.startsWith('solar:') && idle.endsWith('-line-duotone')) {
    return `${idle.slice(0, -'-line-duotone'.length)}-bold-duotone`;
  }

  return idle;
}

/** True si idle y filled son distintos (hay pareja outline/fill). */
export function hasFilledNavIconPair(iconName: string | undefined | null): boolean {
  const idle = (iconName ?? '').trim();
  if (!idle) {
    return false;
  }
  return toFilledNavIcon(idle) !== idle;
}

/**
 * Tabler (`i-tabler` name): idle outline / activo filled.
 * Si no hay filled (p. ej. `building-store`, `logout`), deja el idle.
 */
export function tablerNavIconForState(
  iconName: string | undefined | null,
  active: boolean
): string {
  const idle = (iconName ?? '').trim();
  if (!idle) {
    return '';
  }
  if (!active) {
    return idle;
  }
  return TABLER_FILLED_BY_IDLE[idle] ?? idle;
}
